import { Component, OnInit } from '@angular/core';
import { Router, ActivationEnd } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
public white = false;
public css = 'clearfix content white-bg';
  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof ActivationEnd) {
        if (event.snapshot.url.length > 0) {
          this.css = 'clearfix content white-bg';
        } else {
          this.css = 'clearfix content yellow-bg';
        }
      }
    });

  }

  ngOnInit() {
  }

}
